import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes, faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';

const AgnosticBanner = ({ closeBanner }) => {
  return (
    <div className="mobile-app-banner">
      <a className="mobile-app-close" onClick={closeBanner}><FontAwesomeIcon icon={faTimes} style={{width: "16px", height: "16px", color: "white"}} /></a>
      <div className="mobile-app-link">Important Autzu changes starting March 4, 2020.</div>
      <Link to="./changesFAQ" style={{color: "white", fontSize: "10px", display: "flex", justifyContent: "center", alignItems: "center"}}>
        <div className="banner__read-more"> Read more</div>
        <FontAwesomeIcon icon={faAngleRight} fixedWidth size="1x" />
      </Link>
    </div>
  )
}

export default AgnosticBanner


// WEBPACK FOOTER //
// ./src/components/Layout/AgnosticBanner.js